<template>
  <nav class="pn" aria-label="섹션 이동">
    <div class="pn__row">
      <button
        v-for="p in pills"
        :key="p.lens"
        class="pn__pill"
        :class="{ 'pn__pill--active': isActive(p) }"
        @click="$emit('change', p.lens)"
      >
        {{ p.label }}
      </button>
    </div>
  </nav>
</template>

<script>

export default {
  name: 'HomePillNav',
  props: {
    activeLens: { type: String, default: '' },
    // The app is dark-only in practice (most surfaces hardcode dark colors, so
    // the light theme renders broken), so the theme toggle is hidden by default.
    // Only pass true on a route proven fully tokenized AND light-safe.
  },
  emits: ['change'],
  data() {
    return {
      pills: [
        { lens: 'home', label: '홈' },
        { lens: 'community', label: '소통방' },
        { lens: 'library', label: '표현집' },
        // 자료실 — the two PDF categories (월간 실무 자료 / 비즈영어 표현집).
        // Paying members had NO path to either: the legacy home's extras
        // section was the only entry and it did not survive the revamp.
        { lens: 'books', label: '자료실' },
      ],
    };
  },
  methods: {
    isActive(p) { return p.lens === this.activeLens; },
  },
};
</script>

<style scoped>
/*
  HomePillNav — global top nav.

  Tuned for app-grade mobile feel: 44px touch targets (iOS HIG / Material),
  tactile :active scale, suppressed iOS tap-flash + double-tap delay,
  no accidental text selection on long-press. Desktop padding aligns with
  HeaderLoggedIn's widescreen-padding (50px) so the vertical edge reads
  as one line down the left of the page.
*/
.pn {
  width: 100%;
  background: transparent;
}
.pn__row {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 4px 12px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.pn__row::-webkit-scrollbar { display: none; }

.pn__pill {
  flex: 0 0 auto;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  /* Real 44pt touch target — guaranteed regardless of label length. */
  min-width: 44px;
  min-height: 44px;
  padding: 0 14px;
  border: 0;
  background: transparent;
  font: inherit;
  font-size: 15px;
  font-weight: 500;
  color: var(--text-tertiary);
  letter-spacing: -0.005em;
  white-space: nowrap;
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
  transition:
    color 200ms cubic-bezier(0.22, 1, 0.36, 1),
    transform 140ms cubic-bezier(0.22, 1, 0.36, 1);
}
.pn__pill:hover { color: var(--text-secondary); }
.pn__pill:active { transform: scale(0.95); }
.pn__pill--active { color: var(--text-primary); }
.pn__pill--active::after {
  content: '';
  position: absolute;
  left: 14px;
  right: 14px;
  bottom: 0;
  height: 2px;
  background: var(--text-primary);
  border-radius: 1px;
}

@media (min-width: 768px) {
  .pn__row {
    padding: 4px 50px;
    gap: 6px;
  }
  .pn__pill {
    padding: 0 18px;
  }
  .pn__pill--active::after {
    left: 18px;
    right: 18px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .pn__pill {
    transition: color 160ms ease;
  }
  .pn__pill:active { transform: none; }
}
</style>
